import { ArticleHeading3, LinkButton } from '@cian/ui-kit';
import { IconActionChevronRight16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './JournalHighlights.css';
import { JournalHighlightsItem } from './components/JournalHighlightsItem';
import { IJournalHighlightsItem } from '../../../common/types/journal';

export function JournalHighlightsSection({ children }: React.PropsWithChildren<{}>) {
  return (
    <section className={styles['section']} data-name="JournalHighlights">
      <div className={styles['section-heading']}>
        <ArticleHeading3 as="span">Полезное от Циан.Журнала</ArticleHeading3>
        <LinkButton
          size="XS"
          theme="fill_white_primary"
          href="https://www.cian.ru/magazine/"
          target="_blank"
          afterIcon={<IconActionChevronRight16 color="primary_100" />}
        />
      </div>

      {children}
    </section>
  );
}

interface IJournalHighlightsProps {
  items: IJournalHighlightsItem[];
  onLinkClick(e: React.SyntheticEvent<HTMLAnchorElement>): void;
}

export function JournalHighlightsSlider({ items, onLinkClick }: IJournalHighlightsProps) {
  return (
    <div className={styles['wrapper']}>
      <div className={styles['carousel']}>
        {items.map(({ url, title, img, description }) => (
          <JournalHighlightsItem
            key={title}
            className={styles['card']}
            description={description}
            img={img}
            title={title}
            url={url}
            onClick={onLinkClick}
          />
        ))}
      </div>
    </div>
  );
}
